import React from 'react';
import { 
  Info, 
  MessageCircle, 
  Clock, 
  QrCode, 
  Navigation, 
  MessageSquare,
  DollarSign,
  FileText,
  Camera,
  Settings
} from 'lucide-react';

function DeliveryActions({
  hasNote,
  hasImages,
  hasStatus,
  hasPayment,
  sendingThreeMin,
  onInfoClick,
  onContactClick,
  onThreeMinClick,
  onQRClick,
  onDirectionsClick,
  onChatClick,
  onPaymentClick,
  onNoteClick,
  onCameraClick,
  onStatusClick
}) {
  const ActionButton = ({ icon: Icon, onClick, active, loading }) => (
    <button
      onClick={onClick}
      disabled={loading}
      className={`
        w-12 h-12 rounded-full shadow-lg transition-all
        flex items-center justify-center
        ${active 
          ? 'bg-brand-green text-white' 
          : 'bg-white text-gray-700 hover:bg-gray-50'
        }
        ${loading ? 'opacity-50 cursor-not-allowed' : ''}
        border-2 border-gray-900
      `}
    >
      {loading ? (
        <div className="w-5 h-5 border-2 border-current border-t-transparent rounded-full animate-spin" />
      ) : (
        <Icon className="w-5 h-5" />
      )}
    </button>
  );

  return (
    <>
      {/* Left Side Actions */}
      <div className="absolute left-4 top-1/2 -translate-y-1/2 flex flex-col gap-3" style={{ zIndex: 1000 }}>
        <ActionButton 
          icon={Info} 
          onClick={onInfoClick}
        />
        <ActionButton 
          icon={MessageCircle} 
          onClick={onContactClick}
        />
        <ActionButton 
          icon={Clock} 
          onClick={onThreeMinClick}
          loading={sendingThreeMin}
        />
        <ActionButton 
          icon={QrCode} 
          onClick={onQRClick}
        />
        <ActionButton 
          icon={Navigation} 
          onClick={onDirectionsClick}
        />
        <ActionButton 
          icon={MessageSquare} 
          onClick={onChatClick}
        />
      </div>

      {/* Right Side Actions */}
      <div className="absolute right-4 top-1/2 -translate-y-1/2 flex flex-col gap-3" style={{ zIndex: 1000 }}>
        <ActionButton 
          icon={DollarSign} 
          onClick={onPaymentClick}
          active={hasPayment}
        />
        <ActionButton 
          icon={FileText} 
          onClick={onNoteClick}
          active={hasNote}
        />
        <ActionButton 
          icon={Camera} 
          onClick={onCameraClick}
          active={hasImages}
        />
        <ActionButton 
          icon={Settings} 
          onClick={onStatusClick}
          active={hasStatus}
        />
      </div>
    </>
  );
}

export default DeliveryActions;